module.exports = __webpack_public_path__ + "img/fleetex-home-page.f662e4bf.png";